import { ComponentProps } from 'react';

import { cn } from '@/utils/cn';

type Props = ComponentProps<'div'>;

export const TriggerIndicator = ({ className, ...rest }: Props) => (
    <div
        className={cn(
            `
              flex size-[50px] items-center justify-center self-end rounded-full
              border border-primary-black

              group-hover:border-2
            `,
            className,
        )}
        {...rest}
    >
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            className={cn(
                `
                  stroke-primary-black stroke-1

                  group-hover:stroke-[2px]
                `,
            )}
        >
            <path d="M16 0V32M0 16H32" />
        </svg>
    </div>
);
